import {NgModule} from '@angular/core';
import {ModalComponent} from './modal.component';
import {SharedModule} from '../../shared/shared.module';
import {SimpleModalModule} from 'ngx-simple-modal';

@NgModule({
    imports: [SharedModule, SimpleModalModule.forRoot({container: 'modal-container'})],
    declarations: [ModalComponent],
    exports: [ModalComponent],
})

export class ModalModule {
}
